import React from 'react';
import { ButtonPrimary } from '../StyledComponent';
import { ContainerCardWithAction } from './styles';
const CardWithAction = ({
  imgSrc,
  title,
  subtitle,
  buttonText,
  hideButton,
  onClickButton,
  theme,
}) => {
  const hasShowButton = buttonText && onClickButton && !hideButton;
  const hasShowImg = !!imgSrc;
  const hasShowInfos = title || subtitle;
  return (
    <ContainerCardWithAction>
      {hasShowImg && <img src={imgSrc} alt={`Imagem ${title}`} />}

      {hasShowInfos && (
        <div className='card-with-action-infos-container'>
          {title && <h3 className='card-with-action-title'>{title}</h3>}
          {subtitle && (
            <span className='card-with-action-subtitle'>{subtitle}</span>
          )}
        </div>
      )}

      {hasShowButton && (
        <ButtonPrimary width={300} tema={theme} onClick={onClickButton}>
          {buttonText}
        </ButtonPrimary>
      )}
    </ContainerCardWithAction>
  );
};

export default CardWithAction;
